import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeWidth: 1.5, d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2c2.75 0 5.407 1.15 7.29 3.155l-2.535 2.382A6.46 6.46 0 0 0 12 5.478 6.53 6.53 0 0 0 5.478 12a6.529 6.529 0 0 0 12.685 2.174h-4.859v-3.478H22l-.003 1.83C21.722 17.838 17.33 22 12 22zM6.348 8.696 3.607 6.503m2.81 8.826L3.78 17.703m12.108-.46 2.322 2.612" }));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
